import { HEADER_STYLES } from '../HeaderConstants';

const NavigationTabs = ({ navigationItems, isNavigationActive, handleNavigation }) => {
  return (
    <div className="flex items-center">
      {navigationItems.map((item, index) => (
        <div key={index} className={`flex h-[70px] ${HEADER_STYLES.NAV_BORDER}`}>
          <button 
            onClick={() => handleNavigation(item.path)}
            className={`${HEADER_STYLES.NAV_TAB} ${
              isNavigationActive(item.path) 
                ? HEADER_STYLES.NAV_TAB_ACTIVE
                : HEADER_STYLES.NAV_TAB_INACTIVE
            }`}
          >
            {item.name}
            {/* Bottom border line only when active */}
            {isNavigationActive(item.path) && (
              <div className={HEADER_STYLES.ACTIVE_BORDER}></div>
            )}
          </button>
        </div>
      ))}
    </div>
  );
};

export default NavigationTabs;
